var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-12" },
    [
      _c("v-card-title", [
        _vm._v(" Create User " + _vm._s(_vm.fullName) + " "),
      ]),
      _c("v-divider"),
      _c(
        "v-form",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-text-field", {
                        attrs: {
                          label: "Full Name",
                          "key-error": "FullName",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.fullName,
                          callback: function ($$v) {
                            _vm.fullName = $$v
                          },
                          expression: "fullName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-text-field", {
                        attrs: {
                          label: "Email",
                          "key-error": "Email",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("pga-combobox", {
                        attrs: {
                          "item-value": "Id",
                          "item-text": "Name",
                          items: _vm.allRoles,
                          label: "Roles",
                          multiple: "",
                          "return-object": "",
                          "key-error": "Roles",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.rolesSelected,
                          callback: function ($$v) {
                            _vm.rolesSelected = $$v
                          },
                          expression: "rolesSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("pga-combobox", {
                        attrs: {
                          "return-object": "",
                          "item-text": _vm.getNameEmail,
                          items: _vm.allSIPUsers,
                          label: "SIP Users",
                          multiple: false,
                          "key-error": "SIPCode",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.sipUserSelected,
                          callback: function ($$v) {
                            _vm.sipUserSelected = $$v
                          },
                          expression: "sipUserSelected",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }